import Login from "pages/Authentication/Login";
import Dashboard from "pages/Dashboards";
import UserProfile from "pages/Profile";

import Logout from "pages/Authentication/LogOut";
import BasicResetPassword from "pages/Authentication/ResetPassword";
import OrderForm from "pages/SaleOrder/OrderForm";
import OrderView from "pages/SaleOrder/OrderView";
import Orders from "pages/SaleOrder/Orders";
import Settings from "pages/Settings";

interface RouteObject {
  path: string;
  component: React.ComponentType;
  exact?: boolean;
}

const authProtectedRoutes: Array<RouteObject> = [
  { path: "/", component: Dashboard },
  { path: "/dashboard", component: Dashboard },

  { path: "/sale-orders", component: Orders },
  { path: "/sale-orders/new", component: OrderForm },
  { path: "/sale-orders/edit/:id", component: OrderForm },
  { path: "/sale-orders/view/:id", component: OrderView },

  { path: "/user-profile", component: UserProfile },

  { path: "/settings", component: Settings },
];

const publicRoutes = [
  { path: "/login", component: Login },
  { path: "/logout", component: Logout },

  { path: "/recover-password", component: BasicResetPassword },
];

export { authProtectedRoutes, publicRoutes };
